// extracted by mini-css-extract-plugin
module.exports = {"figure":"trail_figure__1Q-71","selection":"trail_selection__1Vsg1","checkbox":"trail_checkbox__sPri8","caption":"trail_caption__3-Zib","thumbnail":"trail_thumbnail__1Eneu"};